import React, { useState, useEffect } from "react";
import logo from "../assets/logo.png"

const Header = ({ isActiveRoute }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);

  return (
    <header className="relative flex justify-between items-center py-4 px-8 bg-navy text-soft-white">
      {/* Logo */}
      <div className="flex items-center">
        <img 
          src={logo} 
          alt="PaySub Logo" 
          className="w-16 h-16 object-contain"
        />
      </div>

      {/* Hamburger Menu for Mobile */}
      <button
        className="md:hidden text-soft-white focus:outline-none z-50"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d={isMenuOpen 
              ? "M6 18L18 6M6 6l12 12"
              : "M4 6h16M4 12h16m-7 6h7"
            }
          ></path>
        </svg>
      </button>

      {/* Mobile Menu Container */}
      <div 
        className={`${
          isMenuOpen ? "translate-y-0 opacity-100" : "-translate-y-full opacity-0"
        } md:hidden flex-col fixed top-[53px] left-0 w-full h-[calc(100vh-72px)] bg-navy z-40 transition-all duration-300 ease-in-out overflow-y-auto`}
      >
        {/* Navigation Links */}
        <nav className="w-full flex-1">
          <ul className="flex flex-col items-center gap-8 py-12">
            <li>
              <a 
                href="/" 
                onClick={() => setIsMenuOpen(false)}
                className={`block text-lg font-medium hover:text-golden-yellow transform hover:scale-105 transition-all ${isActiveRoute('/') ? 'text-golden-yellow' : ''}`}
              >
                Home
              </a>
            </li>
            <li>
              <a 
                href="/about" 
                onClick={() => setIsMenuOpen(false)}
                className={`block text-lg font-medium hover:text-golden-yellow transform hover:scale-105 transition-all ${isActiveRoute('/about') ? 'text-golden-yellow' : ''}`}
              >
                About
              </a>
            </li>
            <li>
              <a 
                href="/features" 
                onClick={() => setIsMenuOpen(false)}
                className={`block text-lg font-medium hover:text-golden-yellow transform hover:scale-105 transition-all ${isActiveRoute('/features') ? 'text-golden-yellow' : ''}`}
              >
                Features
              </a>
            </li>
            <li>
              <a 
                href="/contact" 
                onClick={() => setIsMenuOpen(false)}
                className={`block text-lg font-medium hover:text-golden-yellow transform hover:scale-105 transition-all ${isActiveRoute('/contact') ? 'text-golden-yellow' : ''}`}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>

        {/* Mobile Actions */}
        <div className="w-full px-8 py-8 border-t border-gray-700/50">
          <div className="flex flex-col items-center gap-6">
            <p className="text-sm text-gray-400">
              Already have an account?
            </p>
            <a 
              href="/login"
              onClick={() => setIsMenuOpen(false)}
              className="text-lg text-golden-yellow hover:text-yellow-400 transform hover:scale-105 transition-all"
            >
              Login
            </a>
            <a 
              href="/signup" 
              onClick={() => setIsMenuOpen(false)}
              className="w-full max-w-[200px] text-center px-6 py-3 bg-golden-yellow text-charcoal-gray rounded-lg font-medium hover:bg-yellow-500 transform hover:scale-105 transition-all"
            >
              Sign Up
            </a>
          </div>
        </div>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:block">
        <ul className="flex items-center gap-6">
          <li>
            <a 
              href="/" 
              className={`py-2 hover:text-golden-yellow transition-colors ${isActiveRoute('/') ? 'text-golden-yellow' : ''}`}
            >
              Home
            </a>
          </li>
          <li>
            <a 
              href="/about" 
              className={`py-2 hover:text-golden-yellow transition-colors ${isActiveRoute('/about') ? 'text-golden-yellow' : ''}`}
            >
              About
            </a>
          </li>
          <li>
            <a 
              href="/features" 
              className={`py-2 hover:text-golden-yellow transition-colors ${isActiveRoute('/features') ? 'text-golden-yellow' : ''}`}
            >
              Features
            </a>
          </li>
          <li>
            <a 
              href="/contact" 
              className={`py-2 hover:text-golden-yellow transition-colors ${isActiveRoute('/contact') ? 'text-golden-yellow' : ''}`}
            >
              Contact
            </a>
          </li>
        </ul>
      </nav>

      {/* Desktop Actions */}
      <div className="hidden md:flex items-center gap-4">
        <p className="text-sm">
          Already have an account?{" "}
          <a href="/login" className="underline text-golden-yellow hover:text-yellow-400 transition-colors">
            Login
          </a>
        </p>
        <a 
          href="/signup" 
          className="px-4 py-2 bg-golden-yellow text-charcoal-gray rounded hover:bg-yellow-500 transform hover:scale-105 transition-all"
        >
          Sign Up
        </a>
      </div>
    </header>
  );
};

export default Header;